$(function () {
    var newCam = document.getElementById('aspectRatio').value;
    var newLens = document.getElementById('lensFOV').value;
    var oldUnit = document.getElementById('unitSwitch').value;
    var unit = document.getElementById('unitSwitch').value;
    var customImager = $('#custom-imager');
    var customFOV = $('#custom-lens');

    let cameras = [
        {name:'PrimeX 13', aspectRatio:1.25, lenses:[610, 354]},
        {name:'PrimeX 13W', aspectRatio:1.25, lenses:[584, 501]},
        {name:'SlimX 13', aspectRatio:1.25, lenses:[584, 610, 354, 501]},
        {name:'Flex 13', aspectRatio:1.25, lenses:[610, 354]},
        {name:'Flex 3', aspectRatio:1.333, lenses:[309, 307, 610]},
        {name:'Slim 3U', aspectRatio:1.333, lenses:[309, 307]}
    ];

    let lenses = [
        {productIndex:584, name:'4.5mm F#2.2 Lens - 1/1.8 - M12', fov:69.0 },
        {productIndex:610, name:'5.5mm F#2.0 Lens - 1/1.8" - M12', fov:56.0 },
        {productIndex:354, name:'8mm F#1.8 Lens - 1/1.8" - M12', fov:43.0 },
        {productIndex:501, name:'3.5mm F#2.4 Lens - 1/2" - M12', fov:82.0 },
        {productIndex:309, name:'3.5mm F#1.6 Lens - 1/3" - M12', fov:58.0 },
        {productIndex:307, name:'4.5mm F#1.6 Lens - 1/3" - M12', fov:46.0 }
    ];

    var outputResults = function() {
        newCam = document.getElementById('aspectRatio').value;
        newLens = document.getElementById('lensFOV').value;

        // hide or display the custom imager & FOV
        customFields();

        // Use the form values to calculate
        fovCalculator(unit);
    };


    var customFields = function() {
        // Show/hide custom imager fields
        if (newCam === 'custom') {
            $(customImager).slideDown();
        }
        else {
            if ( $(customImager).is(':visible') ) {
                $(customImager).slideUp();
            }
        }

        // Show/hide custom lens fields
        if ( newLens === 'custom') {
            $(customFOV).slideDown();
        }
        else {
            if ( $(customFOV).is(':visible') ) {
                $(customFOV).slideUp();
            }
        }
    };


    var fovCalculator = function(unit) {
        let selectedCameraIndex = document.getElementById('aspectRatio').value;
        var aspectRatio = selectedCameraIndex;
        var horizontalAngle = document.getElementById('lensFOV').value;
        var cameraDistance = document.getElementById('cameraDistance').value;

        // Calculate custom aspect ratio if applicable
        if (aspectRatio === 'custom') {
            var imagerWidth = document.getElementById('imagerWidth').value;
            var imagerHeight = document.getElementById('imagerHeight').value;

            if ( isNaN(imagerWidth) || isNaN(imagerHeight) ) {
                return false;
            }
            else {
                aspectRatio = imagerWidth / imagerHeight;
            }
        }else{
            // use the aspectRatio from the cameras array
            aspectRatio = cameras[selectedCameraIndex].aspectRatio;
        }

        // Calculate custom lens FOV if applicable
        if (horizontalAngle === 'custom') {
            horizontalAngle = document.getElementById('customFOV').value;

            if ( isNaN(horizontalAngle) ) {
                return false;
            }
        }

        // Grab the current unit value if undefined
        if ( typeof unit === 'undefined') {
            unit = document.getElementById('unitSwitch').value;
        }

        // Calculate and show/hide final output
        if ( ( !isNaN(aspectRatio) ) && ( !isNaN(horizontalAngle) ) && ( ( !isNaN(cameraDistance) ) && (cameraDistance > 0) ) ) {

            // Showing the results for the first time?
            if ( document.getElementById('calculator-results').classList.contains('hide') ) {

                calculateResults(aspectRatio, horizontalAngle, cameraDistance);

                //$('#calculator-results').fadeIn('slow');
                document.getElementById('calculator-results').classList.add('fadeIn');
                document.getElementById('calculator-results').classList.remove('hide');
            }
            else {

                // remove old fade classes
                document.getElementById('horizontalWrapper').classList.remove('fadeIn');
                document.getElementById('horizontalWrapper').classList.remove('fadeOut');
                document.getElementById('verticalWrapper').classList.remove('fadeIn');
                document.getElementById('verticalWrapper').classList.remove('fadeOut');
                document.getElementById('widthWrapper').classList.remove('fadeIn');
                document.getElementById('widthWrapper').classList.remove('fadeOut');
                document.getElementById('heightWrapper').classList.remove('fadeIn');
                document.getElementById('heightWrapper').classList.remove('fadeOut');

                // Event listener triggered after fadeOut animation plays
                document.getElementById('horizontalWrapper').addEventListener('animationend', (event) => {

                    // Update units
                    document.getElementById('widthUnits').innerHTML = unit;
                    document.getElementById('heightUnits').innerHTML = unit;

                    // Calculate results
                    calculateResults(aspectRatio,horizontalAngle,cameraDistance);

                    // fade in new values
                    document.getElementById('horizontalWrapper').classList.add('fadeIn');
                    document.getElementById('horizontalWrapper').classList.remove('fadeOut');
                    document.getElementById('verticalWrapper').classList.add('fadeIn');
                    document.getElementById('verticalWrapper').classList.remove('fadeOut');
                    document.getElementById('widthWrapper').classList.add('fadeIn');
                    document.getElementById('widthWrapper').classList.remove('fadeOut');
                    document.getElementById('heightWrapper').classList.add('fadeIn');
                    document.getElementById('heightWrapper').classList.remove('fadeOut');
                }, {once: true});

                // fade out old values
                document.getElementById('horizontalWrapper').classList.add('fadeOut');
                document.getElementById('verticalWrapper').classList.add('fadeOut');
                document.getElementById('widthWrapper').classList.add('fadeOut');
                document.getElementById('heightWrapper').classList.add('fadeOut');

            }
        }

        oldUnit = unit;
    };


    var calculateResults = function(aspectRatio,horizontalAngle,cameraDistance) {
        // Calculate viewing width
        var resolvedWidth = ( Math.tan ( (horizontalAngle / 2) * (3.141592654 / 180) ) * cameraDistance ) * 2;
        document.getElementById('viewingWidth').innerHTML = resolvedWidth.toFixed(2);

        // Calculate viewing height as a factor of viewing width
        var viewingHeight = resolvedWidth / aspectRatio;
        document.getElementById('viewingHeight').innerHTML = viewingHeight.toFixed(2);

        // Calculate vertical angle as a factor of horizontal angle
        var verticalAngle = horizontalAngle / aspectRatio;
        document.getElementById('verticalAngle').innerHTML = verticalAngle.toFixed(1);

        // Output horizontal angle (FOV)
        document.getElementById('horizontalAngle').innerHTML = horizontalAngle;
    };


    // Unit conversions
    updateUnits = () => {
        unit = document.getElementById('unitSwitch').value;
        var oldDistance = document.getElementById('cameraDistance').value;
        var newDistance;

        if ( unit === 'ft' ) {
            if (oldUnit === 'm') { newDistance = oldDistance * 3.2808399; }
            if (oldUnit === 'in') { newDistance = oldDistance * 0.083333333; }
            if (oldUnit === 'cm') { newDistance = oldDistance * 0.032808399; }
        }
        else if ( unit === 'm' ) {
            if (oldUnit === 'ft') { newDistance = oldDistance * 0.3048; }
            if (oldUnit === 'in') { newDistance = oldDistance * 0.0254; }
            if (oldUnit === 'cm') { newDistance = oldDistance * 0.01; }
        }
        else if ( unit === 'in' ) {
            if (oldUnit === 'ft') { newDistance = oldDistance * 12; }
            if (oldUnit === 'm') { newDistance = oldDistance * 39.370079; }
            if (oldUnit === 'cm') { newDistance = oldDistance * 0.39370079; }
        }
        else if ( unit === 'cm' ) {
            if (oldUnit === 'ft') { newDistance = oldDistance * 30.48; }
            if (oldUnit === 'm') { newDistance = oldDistance * 100; }
            if (oldUnit === 'in') { newDistance = oldDistance * 2.54; }
        }

        newDistance = newDistance.toFixed(2);
        document.getElementById('cameraDistance').value =newDistance;
        outputResults(unit);
    };

    // Update units when changed
    document.getElementById('unitSwitch').addEventListener('change', updateUnits);

    // Update values when lens is changed
    document.getElementById('lensFOV').addEventListener('change', outputResults);

    // Update values when distance is changed
    document.getElementById('cameraDistance').addEventListener('input', outputResults);


    customFields();

    // Populates the camera select field
    populateCameras = () => {
        cameraSelect = document.getElementById('aspectRatio');
        cameraSelect.innerHTML = '';
        cameras.forEach((camera, index) => {
            let cameraOption = document.createElement('option');
            cameraOption.innerHTML = camera.name;
            cameraOption.setAttribute('value',index);
            cameraSelect.appendChild(cameraOption);
        });
        let customOption = document.createElement('option');
        customOption.innerHTML = 'Custom Imager';
        customOption.setAttribute('value','custom');
        cameraSelect.appendChild(customOption);

        populateLenses(0);
    }

    cameraChangeEventHandler = (event) => {
        let selectedCamera = document.getElementById('aspectRatio').value;
        populateLenses(selectedCamera);
        outputResults();
    }

    // Populates the Lenses select field based on the camera selected
    populateLenses = (cameraIndex) => {
        lensSelect = document.getElementById('lensFOV');
        lensSelect.innerHTML = '';

        // Add all lenses if 'custom' is selected
        if(cameraIndex === 'custom'){
            lenses.forEach((lense) => {
                let lenseOption = document.createElement('option');
                lenseOption.innerHTML = lense.name;
                lenseOption.setAttribute('value', lense.fov);
                lensSelect.appendChild(lenseOption);
            })
        // Add lenses compatible with the selected camera
        }else{
            cameraLenses = cameras[cameraIndex].lenses;
            cameraLenses.forEach((cameraLens) => {
                lenses.forEach((lense) => {
                    if(cameraLens === lense.productIndex){
                        let lenseOption = document.createElement('option');
                        lenseOption.innerHTML = lense.name;
                        lenseOption.setAttribute('value', lense.fov);
                        lensSelect.appendChild(lenseOption);
                    }
                })
            });
        }
        let customLens = document.createElement('option');
        customLens.innerHTML = 'Custom Horizontal FOV';
        customLens.setAttribute('value','custom');
        lensSelect.appendChild(customLens);

        // Run for the first time
        outputResults();
    }

    initialize = () => {
       // populate the camera select
       populateCameras();
    }

    // When window is loaded...
    window.onload = (event) => {

        initialize();

        //Event listeners
        document.getElementById('aspectRatio').addEventListener('change', cameraChangeEventHandler);

    };

});
